'use client';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { NavbarConfig } from '@practium/ui';
import { getRouteTitle } from '../utils/getRouteTitle';

interface UseNavigationProps {
	navbarConfig: NavbarConfig;
	customTitles?: Record<string, string>;
}

export const useNavigation = ({ navbarConfig, customTitles }: UseNavigationProps) => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const location = useLocation();

	const handleMenuClick = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	const handleCloseSidebar = () => {
		setIsSidebarOpen(false);
	};

	useEffect(() => {
		setIsSidebarOpen(false);
	}, [location.pathname]);

	const currentTitle = getRouteTitle(location.pathname, customTitles);

	const dynamicNavbarConfig: NavbarConfig = {
		...navbarConfig,
		title: navbarConfig.titleContent ? navbarConfig.title : currentTitle,
	};

	return {
		isSidebarOpen,
		handleMenuClick,
		handleCloseSidebar,
		dynamicNavbarConfig,
	};
};
